import React from 'react'
import { StarbaseLoan, GameBoard } from '@prometheus/types'
import './PlanetDetailsDisplayLoan.scss'
import PromiseDiv from '../../../../components/PromiseDiv'
import usePlayerActions from '../../hooks/usePlayerActions'
import { truncateCash } from '@prometheus/utils'
import { Box, Card, Table, TableBody, TableCell, TableHead, TableRow } from '@prometheus/components'
import PromiseTableRow from '@/components/PromiseTableRow'

interface PlanetDetailsDisplayLoanProps {
  deed: StarbaseLoan
  planet: keyof GameBoard
}

export const PlanetDetailsDisplayLoan = ({ deed, planet }: PlanetDetailsDisplayLoanProps) => {
  const {
    onUpgradePlanet,
  } = usePlayerActions()

  return (
    <Box space="sm">
      <Card padding="none">
        <Table striped hoverable size="sm">
          <TableHead>
            <TableRow variant="head">
              <TableCell style={{ fontSize: '1.2rem' }} variant="head">Amount</TableCell>
              <TableCell style={{ fontSize: '1.2rem' }} variant="head">Cost</TableCell>
              <TableCell style={{ fontSize: '1.2rem' }} variant="head">Rate</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {deed.offer.map((loan) => {
              return (
                <PromiseTableRow key={loan.amount} style={{ cursor: 'pointer' }} onClick={() => onUpgradePlanet([planet, loan.amount], 'starbase')}>
                  <TableCell style={{ color: 'var(--prometheus-primary)' }}>{truncateCash(loan.amount).replace('.00', '')}</TableCell>
                  <TableCell style={{ color: 'var(--prometheus-danger)' }}>{truncateCash(loan.cost).replace('.00', '')}</TableCell>
                  <TableCell>{(loan.cost / loan.amount * 100).toFixed(1)}%</TableCell>
                </PromiseTableRow>
              )
            })}
          </TableBody>
        </Table>
      </Card>
    </Box>
  )
}
